import React, { useEffect, useState } from "react";
import Footer11 from "../shared/Footer11";
import Navbar11 from "../shared/Navbar11";
import Sidebar11 from "../shared/Sidebar11";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import {
  MdOutlineKeyboardDoubleArrowRight,
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardArrowLeft,
} from "react-icons/md";

function Consolidatedchecklist11() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  const [showPdfViewer, setShowPdfViewer] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");

  useEffect(() => {
    const fetchStudentData = async () => {
      const token = sessionStorage.getItem("tokenclassxi");

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/ConsolidateListOfStudent_CL11`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const result = await response.json();
        if (response.ok) {
          setLoading(false);
          setStudents(result?.data.consolidateStudentCL11_list || []);
        } else {
          setLoading(false);
          console.error("Failed to fetch students", result);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching student data:", error);
      }
    };

    fetchStudentData();
  }, []);

  const closePdfViewer = () => {
    setShowPdfViewer(false);
    setPdfUrl("");
  };
  // Filter logic
  const filteredStudents = students.filter((student) => {
    const query = searchQuery.toLowerCase();
    return student.candidatE_NAME?.toLowerCase().includes(query);
  });

  // Pagination logic
  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  const handleDownloadClick = () => {
    setPdfUrl("/list-of-examinees-cl-11");
    setShowPdfViewer(true);
  };
  return (
    <>
      <div class="container-scroller">
        <Navbar11 />
        <div class="container-fluid page-body-wrapper">
          <Sidebar11 />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header">
                    <h1>
                      <i class="fa fa-user"></i>&nbsp; List of Registered Students
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/class-xi-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> List of Registered Students</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-body">
                      <div className="row mb-2">
                        {students.length > 0 && (
                          <div style={{ textAlign: "right" }}>
                            {/* <a
                              className="btn btn-sm btn-success"
                              href="#"
                              onClick={() =>
                                window.open("/list-of-examinees-cl-9", "_blank")
                              }
                            >
                              <i className="fa fa-download"></i>&nbsp;Download
                              List of Registered Students
                            </a> */}
                            <a
                              className="btn btn-sm btn-success"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleDownloadClick();
                              }}
                            >
                              <i className="fa fa-download"></i>&nbsp;Download
                              List of Registered Students
                            </a>
                          </div>
                        )}
                      </div>
                      <div className="row align-items-center justify-content-between mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <div className="d-flex align-items-center">
                            <label htmlFor="rowsPerPage" className="me-2 mb-0">
                              Rows:
                            </label>
                            <div style={{ width: "150px" }}>
                              <select
                                id="rowsPerPage"
                                className="form-select form-select-sm"
                                value={perPage}
                                onChange={handlePerPageChange}
                                style={{
                                  width: "80px", // or adjust as needed (80–120px)
                                  paddingRight: "2rem", // ensures space for the dropdown arrow
                                }}
                              >
                                {[10, 20, 50, 100, 500].map((num) => (
                                  <option key={num} value={num}>
                                    {num}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          {/* Search on the right */}
                          <div style={{ width: "200px" }}>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Search..."
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div
                          className="col-md-12"
                          style={{ overflowX: "auto", width: "100%" }}
                        >
                          <table class="table table-bordered table-condensed table-striped">
                            <thead>
                              <tr>
                                <th colSpan="11">Student Details</th>
                                <th colSpan="8">Communication Details</th>
                                <th colSpan="2">Educational Details</th>
                                <th colSpan="2">Paper 1</th>
                                <th colSpan="5">Paper 2</th>
                                <th colSpan="2">Paper 3</th>
                                <th></th>
                              </tr>
                              <tr className="table-primary">
                                <th>Sl No.</th>
                                <th>Name of Candidate</th>
                                <th>Gender</th>
                                <th>Date of Birth</th>
                                <th>Father's Name</th>
                                <th>Mother's Name</th>
                                <th>Religion</th>
                                <th>Nationality</th>
                                <th>Aadhaar Number</th>
                                <th>Divyang</th>
                                <th>Caste</th>

                                <th>Area</th>
                                <th>State</th>
                                <th>District</th>
                                <th>Block</th>
                                <th>Address</th>
                                <th>Pin</th>
                                <th>Student Contact Number</th>
                                <th>Email ID</th>

                                <th>Category</th>
                                <th>Stream</th>

                                <th>Core Language</th>
                                <th>Matri Bhasa</th>

                                <th>Compulsory I Subject</th>
                                <th>Compulsory II Subject</th>
                                <th>Optional 1 </th>
                                <th>Optional 2</th>
                                <th>Optional 3 </th>

                                <th>Optional 1</th>
                                <th>Optional 2 </th>

                                <th>Elective subject</th>

                                <th>Additional subject</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentItems.length > 0 ? (
                                currentItems.map((student, index) => (
                                  <tr key={index}>
                                    <td>{indexOfFirstItem + index + 1}</td>
                                    <td>{student.candidatE_NAME || ""}</td>
                                    <td>{student.gender || ""}</td>
                                    <td>{student.dob || ""}</td>
                                    <td>{student.fatheR_NAME || ""}</td>
                                    <td>{student.motheR_NAME || ""}</td>
                                    <td>{student.religioN_NAME || ""}</td>
                                    <td>{student.nationality || ""}</td>
                                    <td>{student.aadhaR_CARD || ""}</td>
                                    <td>{student.divyanG_NAME || ""}</td>
                                    <td>{student.castE_NAME || ""}</td>
                                    <td>{student.area || ""}</td>
                                    <td>{student.state || ""}</td>
                                    <td>{student.district || ""}</td>
                                    <td>{student.blocK_NAME || ""}</td>
                                    <td>{student.address || ""}</td>
                                    <td>{student.pincode || ""}</td>
                                    <td>{student.contacT_NO || ""}</td>
                                    <td>{student.emaiL_ID || ""}</td>
                                    <td>
                                      {student.studenT_EXAM_SUB_CATEGORY || ""}
                                    </td>
                                    <td>{student.stream || ""}</td>
                                    <td>{student.subjecT_1_A || ""}</td>
                                    <td>{student.subjecT_1_B || ""}</td>
                                    <td>
                                      {student.stream === "SCIENCE" ||
                                      student.stream === "COMMERCE"
                                        ? student.subjecT_2
                                        : ""}
                                    </td>
                                    <td>
                                      {" "}
                                      {student.stream === "SCIENCE" ||
                                      student.stream === "COMMERCE"
                                        ? student.subjecT_3
                                        : ""}
                                    </td>
                                    <td>
                                      {" "}
                                      {student.stream === "ARTS"
                                        ? student.subjecT_2
                                        : ""}
                                    </td>
                                    <td>
                                      {" "}
                                      {student.stream === "ARTS"
                                        ? student.subjecT_3
                                        : ""}
                                    </td>
                                    <td>
                                      {" "}
                                      {student.stream === "ARTS"
                                        ? student.subjecT_4
                                        : ""}
                                    </td>
                                    <td>
                                      {" "}
                                      {student.stream === "SCIENCE" ||
                                      student.stream === "COMMERCE"
                                        ? student.subjecT_4
                                        : ""}
                                    </td>
                                    <td>
                                      {" "}
                                      {student.stream === "SCIENCE" ||
                                      student.stream === "COMMERCE"
                                        ? student.subjecT_5
                                        : ""}
                                    </td>
                                    <td>
                                      {" "}
                                      {student.stream === "ARTS"
                                        ? student.subjecT_5
                                        : ""}
                                    </td>
                                    <td>{student.subjecT_6 || ""}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="32">No data found</td>
                                </tr>
                              )}
                            </tbody>
                            {/* <tfoot>
                                <tr>
                                    <td colSpan="13">
                                        <a className="btn btn-sm btn-danger">Submit to DEO&nbsp;<i className="fa fa-arrow-right"></i></a>
                                    </td>
                                </tr>
                            </tfoot> */}
                          </table>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                          Showing {indexOfFirstItem + 1} to{" "}
                          {Math.min(indexOfLastItem, filteredStudents.length)}{" "}
                          of {filteredStudents.length} entries
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <MdOutlineKeyboardDoubleArrowLeft
                            onClick={() => setCurrentPage(1)}
                            style={{
                              cursor:
                                currentPage > 1 ? "pointer" : "not-allowed",
                              opacity: currentPage > 1 ? 1 : 0.5,
                            }}
                          />
                          <MdOutlineKeyboardArrowLeft
                            onClick={() =>
                              currentPage > 1 &&
                              setCurrentPage((prev) => prev - 1)
                            }
                            style={{
                              cursor:
                                currentPage > 1 ? "pointer" : "not-allowed",
                              opacity: currentPage > 1 ? 1 : 0.5,
                            }}
                          />
                          <span>
                            Page {currentPage} of {totalPages}
                          </span>
                          <MdOutlineKeyboardArrowRight
                            onClick={() =>
                              currentPage < totalPages &&
                              setCurrentPage((prev) => prev + 1)
                            }
                            style={{
                              cursor:
                                currentPage < totalPages
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: currentPage < totalPages ? 1 : 0.5,
                            }}
                          />
                          <MdOutlineKeyboardDoubleArrowRight
                            onClick={() => setCurrentPage(totalPages)}
                            style={{
                              cursor:
                                currentPage < totalPages
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: currentPage < totalPages ? 1 : 0.5,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {showPdfViewer && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.8)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "90%",
                    height: "90%",
                    backgroundColor: "white",
                    borderRadius: "8px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* HEADER */}
                  <div
                    style={{
                      padding: "10px",
                      borderBottom: "1px solid #ddd",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h5 style={{ margin: 0 }}>Checklist PDF</h5>
                    <button
                      onClick={closePdfViewer}
                      style={{
                        background: "#dc3545",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        padding: "8px 16px",
                        cursor: "pointer",
                      }}
                    >
                      Close
                    </button>
                  </div>

                  {/* IFRAME VIEWER */}
                  <iframe
                    src={pdfUrl}
                    style={{
                      width: "100%",
                      height: "calc(100% - 60px)",
                      border: "none",
                      borderRadius: "0 0 8px 8px",
                    }}
                    title="PDF Viewer"
                  />
                </div>
              </div>
            )}
            <Footer11 />
          </div>
        </div>
      </div>
    </>
  );
}

export default Consolidatedchecklist11;
